<template>
  <div class="terminal-refund-index">
    <basic-container>
      <TerminalRefundSearch
        :channel-options="channelOptions"
        @search="handleSearch"
        @export="handleExport"
      />
      
      <div class="table-container">
         <TerminalRefundTable
           :table-data="tableData"
           :loading="loading"
           @process="openProcessDialog"
           @detail="openDetailDialog"
         />
      </div>

      <div class="pagination-container">
        <ElementPagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="page.currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page.pageSize"
          :total="page.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>

      <TerminalProcessDialog
        :visible.sync="processVisible"
        :refund-detail="currentRefund"
        @success="getList"
      />
      
      <TerminalDetailDialog
        :visible.sync="detailVisible"
        :refund-detail="currentRefund"
      />
    </basic-container>
  </div>
</template>

<script>
import TerminalRefundSearch from './components/search.vue'
import TerminalRefundTable from './components/table.vue'
import TerminalProcessDialog from './components/ProcessDialog.vue'
import TerminalDetailDialog from './components/DetailDialog.vue'
import ElementPagination from '@/components/ElementPagination'
import { 
  supplementList, 
  exportRefundList,
  getChannelOptions 
} from '@/api/memberNew/terminal'
import moment from 'moment'

export default {
  name: 'TerminalRefundIndex',
  components: {
    TerminalRefundSearch,
    TerminalRefundTable,
    TerminalProcessDialog,
    TerminalDetailDialog,
    ElementPagination
  },
  data() {
    return {
      channelOptions: [],
      tableData: [],
      loading: false,
      page: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      searchParams: {},
      processVisible: false,
      detailVisible: false,
      currentRefund: {},
      refundStatusMap: {
        0: '待处理',
        1: '已退款',
        2: '退款失败',
        3: '拒绝退款',
        4: '退款中'
      },
      refundFunMap: {
        1: '退款不退货',
        2: '退款退货'
      }
    }
  },
  created() {
    this.fetchChannelOptions()
    this.getList()
  },
  methods: {
    fetchChannelOptions() {
      getChannelOptions('order').then(res => {
        if (res.data.data) {
          this.channelOptions = res.data.data
        }
      })
    },
    getList() {
      this.loading = true
      
      const params = {
        ...this.searchParams,
        page: this.page.currentPage,
        limit: this.page.pageSize
      }
      
      supplementList(params).then(res => {
        const data = res.data
        if (data && data.code === 200) {
           const list = data.data.records || []
           this.tableData = list
           this.page.total = data.data.total
        } else {
           this.$message.error(data.msg || '获取列表失败')
           this.tableData = []
           this.page.total = 0
        }
      }).catch(err => {
        console.error(err)
        this.tableData = []
        this.page.total = 0
      }).finally(() => {
        this.loading = false
      })
    },
    handleSearch(params) {
      this.searchParams = params
      this.page.currentPage = 1
      this.getList()
    },
    async handleExport(params) {
      try {
        await this.$confirm('确认导出当前数据吗？', '提示', {
          type: 'warning'
        })
        
        // 使用 exportRefundList API
        const res = await exportRefundList(params)
        const data = res.data
        
        if (data) {
          const blob = new Blob([data])
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.download = '退款订单数据_' + moment().format('YYYYMMDDHHmmss') + '.xlsx'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
          this.$message.success('导出成功')
        }
      } catch (err) {
        if (err !== 'cancel') {
           console.error(err)
           this.$message.error('导出失败')
        }
      }
    },
    handleSizeChange(val) {
      this.page.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.page.currentPage = val
      this.getList()
    },
    prepareRefundDetail(row) {
      // 准备弹窗所需的数据，主要是 text 转换
       return {
         ...row,
         refundStatusText: this.refundStatusMap[row.status] || row.status,
         refundFunText: this.refundFunMap[row.refundWay] || '-'
       }
    },
    openProcessDialog(row) {
      this.currentRefund = this.prepareRefundDetail(row)
      this.processVisible = true
    },
    openDetailDialog(row) {
      this.currentRefund = this.prepareRefundDetail(row)
      this.detailVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.terminal-refund-index {
  .table-container {
    margin-top: 16px;
  }

  .pagination-container {
    margin-top: 16px;
    display: flex;
    justify-content: flex-end;
    padding: 16px;
    background-color: #fff;
    border-radius: 4px;
  }
}
</style>
